module.exports = __webpack_public_path__ + "static/media/icon-body-back.d2ff7984.png";